import { SECTION_NAMES } from '@bridebook/web/lib/wedding-website/constants';
import { Faq } from './faq';
import { GiftList } from './gift-list';
import { Hotels } from './hotels';
import { OurStory } from './our-story';
import { Schedule } from './schedule';
import { Venue } from './venue/venue';

/**
 * Maps section names to their corresponding React components for view-mode layouts.
 * Used to dynamically render sections in the order defined by website.sections.
 */
export const SECTION_COMPONENTS: Record<string, React.ReactNode> = {
  [SECTION_NAMES.OUR_STORY]: <OurStory />,
  [SECTION_NAMES.SCHEDULE]: <Schedule />,
  [SECTION_NAMES.PRIMARY_VENUE]: <Venue />,
  [SECTION_NAMES.GIFT_LIST]: <GiftList />,
  [SECTION_NAMES.HOTELS]: <Hotels />,
  [SECTION_NAMES.FAQ]: <Faq />,
};
